import React, { Component } from "react";
import Loading from "../../hoc/Loading/Loading";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import axios from "../../axios";
import "./Groups.css";
import * as url from "../../utils/url";
import { groupRoleAlerts, grpBannerImg } from "../../utils/constants";
import moment from "moment";

import AddToGroupBtn from "../../components/AddToEvent/AddToGroupBtn";
import PostTileComponent from "../../components/PostTileComponent";
import { isMobile } from "../../utils/deviceInfo";
import { Alert } from "reactstrap";

class GroupListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // groups:[],
      item: this.props.item,
      memberCount: this.props.item.members.length,
    };
  }

  componentDidMount() {
    this.setState({
      item: this.props.item,
      memberCount: this.props.item.members.length,
    });
  }

  incrementMemberCount = (val) => {
    let { memberCount } = this.state;
    memberCount = memberCount + val;
    this.setState({ memberCount });
  };

  goToGroupPage = (group) => {
    let { profile } = this.props.user;
    this.props.history.push(
      `/home/groups/${profile.organizationId._id}/view/${group._id}`
    );
  };

  renderAddGrpBtn = () => {
    let { groupType, user } = this.props;
    const { item } = this.state;
    // let is_member =
    //   item.members.filter((e) => e.o_id == user.profile._id.toString()).length >
    //   0;

      let is_member = 0
      
      if( item.members.filter((e) => e.o_id == user.profile._id.toString()).length>0 ){
        is_member=1
        let curr_mem = item.members.filter((e) => e.o_id == user.profile._id.toString())[0]
        if(curr_mem.isAnonymous){
          is_member=4 // 4 is anonymous in the groupRSVP
        }
      }

      console.log(item.name, ' ---- is_member --- ', is_member)

    if (groupType == 0) {
      return (
        <div>
          {is_member>0 ? (
            <AddToGroupBtn
              groupType={this.props.groupType}
              isGroupList={true}
              mod_height={"35px"}
              isParentType={3}
              is_member={is_member}
              incrementMemberCount={this.incrementMemberCount}
              changeEventStatus={this.changeEventStatus}
              item={item}
            />
          ) : (
            <div>


              {item.privacy == "ENTERPRISE" ? (
                <span className="grp-list-itm-dd-nj">
                  <AddToGroupBtn
                    groupType={this.props.groupType}
                    isGroupList={true}
                    mod_height={"35px"}
                    isParentType={3}
                    is_member={is_member}
                    incrementMemberCount={this.incrementMemberCount}
                    changeEventStatus={this.changeEventStatus}
                    item={item}
                  />
                </span>
              ) : (
               <Alert color={item.privacy==="PRIVATE"?"warning":"danger"} className="px-2 mt-3 mb-0 align-g-list"> <span style={{fontSize:"15px",fontWeight:"bold"}}>{groupRoleAlerts({
                  role: -1,
                  privacy: item.privacy,
                  inviteOnly:item.privacy=="INVITE"
                })} </span> </Alert>
              )}
            </div>
          )}
        </div>
      );
    } else if (groupType == 1) {
      return <div className="single_group_menu_joined_group">Joined</div>;
    } else if (groupType == -1) {
      return <div className="grp_list_archived_grp_item">Archived</div>;
    }
  };

  render() {
    const { item, memberCount } = this.state;
    let bannerImg;

    //if (isMobile) {
    //  return (
    //    <PostTileComponent
    //      postTitle={item.name}
    //      postSubtext={`created on ${moment(item.createdOn).format(
    //        "MMM Do, YYYY"
    //      )}`}
    //      postImage={
    //        item && item.bannerImg && item.bannerImg.url
    //          ? item.bannerImg.url
    //          : grpBannerImg
    //      }
    //      postButton={item && item.members ? this.renderAddGrpBtn() : null}
    //      onClickMainContent={() => this.props.goToGroupPage(item)}
    //    />
    //  );
    //} else {
    return (
      <div className="card linkedChartItemStyling group_list_items_container group_list_items_001">
        <img
          src={
            item && item.bannerImg && item.bannerImg.url
              ? item.bannerImg.url
              : grpBannerImg
          }
          // "https://unsplash.it/800/600?image=59"
          onClick={() => this.props.goToGroupPage(item)}
        />

        <div className="card-body">
          <span onClick={() => this.props.goToGroupPage(item)}>
            <span className="grp_list_page_item_title">{item.name}</span>
            <span className="grp_list_page_item_details"></span> &nbsp;
            <span className="grp_list_page_item_details">
              · {memberCount} {memberCount > 1 ? "members" : "member"}
            </span>
          </span>

          {item && item.members ? this.renderAddGrpBtn() : null}
        </div>
      </div>
    );
  }
}
//}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    objectives: state.enterpriseObjective.objectives,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchEnterpriseObjectives: (data) =>
      dispatch(actionCreators.storeEnterpriseObjectives(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    resetObjective: () => dispatch(actionCreators.resetEnterpriseObjectives()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupListItem);
